import React, { Component, useEffect } from 'react';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../../consts';
import InputSelect from '../../components/inputs/InputSelect';
import InputNumber from '../../components/inputs/InputNumber';
import { InputCheckbox, InputText } from '../../components/inputs';
import { toast } from 'react-toastify';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalBody
} from 'reactstrap';
import classnames from 'classnames';
import { withTheme } from 'styled-components';
import { get } from 'lodash';
import { Link } from 'react-router-dom';

class GPTForm extends Component {
  state = {
    loading: false
  };
  handleFilterChange = (filters) => {
    this.props.onFilterChange(filters);
  };

  state = {
    etapaOption: [],
    areaConhecimentoOption: [],
    componenteCurricularOption: [],
    habilidadeOption: [],
    periodoOptions: [],
    momentosOptions: [],
    booksOptions: [],
    matrizReferenciaOption: [],
    typesofgenerators: 2,
    selectedAreaConhecimento: null,
    selectedComponenteCurricular: null,
    selectedPeriodo: null,
    paginaInicial: '',
    bookInfo: null,
    bookThumbnail: '',
    pdfUrl: '',
    isLoading: false,
    apiInfo: {},
    typesofgeneratorsMap: []
  };

  componentDidMount() {
    this.fetchApiResponse();
  }

  fetchMe() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data });
      })
      .catch((response) => toast.error(response.error));
  }

  fetchNivel = () => {
    axios.get(`${API_HOST}/core/periodo`).then((response) => {
      const options = [];

      response.data.map((mapResponse) => {
        if (mapResponse.etapa_nr) {
          options.push({
            value: mapResponse.id,
            label: mapResponse.descricao,
            codigo: mapResponse.etapa_nr
          });
        }
      });
      this.setState({ periodoOptions: options });
    });
  };

  fetchAreasConhecimento() {
    axios.get(`${API_HOST}/core/area_conhecimento`).then((response) => {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.descricao
      }));
      this.setState({ areaConhecimentoOption: options });
    });
  }

  fetchComponentesCurriculares(id) {
    axios
      .get(`${API_HOST}/core/componente_curricular?area_conhecimento_id=${id}`)
      .then((response) => {
        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: mapResponse.descricao
        }));
        this.setState({ componenteCurricularOption: options });
      });
  }

  fetchHabilidade() {
    if (this.state.apiInfo.matriz && this.state.apiInfo.area) {
      axios
        .get(
          `${API_HOST}/matriz_referencia/habilidade?&area_conhecimento_id=${this.state.apiInfo.area}&matriz_id=${this.state.apiInfo.matriz}`
        )
        .then((response) => {
          const options = response.data.results.map((mapResponse) => ({
            value: mapResponse.id,
            label: `${mapResponse.cd_habilidade} - ${mapResponse.ds_habilidade}`
          }));
          this.setState({ habilidadeOption: options });
        });
    }
  }

  fetchMomentos() {
    axios
      .get(`${API_HOST}/openai/moments`)
      .then((response) => {
        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: mapResponse.descricao,
          codigo: mapResponse.codigo
        }));

        this.setState({ momentosOptions: options });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  fetchBooks() {
    axios
      .get(`${API_HOST}/openai/books`)
      .then((response) => {
        const options = response.data.map((response) => ({
          thumbnail: response.image_thumbnail,
          url: response.url,
          value: response.id,
          label: response.descricao
        }));

        this.setState({ booksOptions: options });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  fetchMatrizReferencia(id) {
    let areaConhecimentoId = null;

    if (id) {
      areaConhecimentoId = id;
    }
    axios
      .get(`${API_HOST}/matriz_referencia/matriz_referencia`, {
        params: {
          status: 1,
          areas_conhecimento__id: areaConhecimentoId
        }
      })
      .then((response) => {
        const options = response.data.map((x) => ({
          value: x.id,
          label: x.descricao
        }));
        this.setState({ matrizReferenciaOption: options });
      })
      .catch((error) => console.error(error));
  }

  fetchtypesofgenerators() {
    axios.get(`${API_HOST}/openai/typesofgenerators`).then((response) => {
      this.setState({ typesofgeneratorsMap: response.data });
    });
  }

  componentDidMount() {
    this.fetchMe();
    this.fetchAreasConhecimento();
    this.fetchNivel();
    this.fetchHabilidade();
    this.fetchMatrizReferencia();
    this.fetchMomentos();
    this.fetchBooks();
    this.fetchtypesofgenerators();
  }

  formApiData = () => {
    const { history } = this.props;
    const values = this.state.apiInfo;

    const { typesofgenerators } = this.state;
    const paramsValues = {
      ...values
    };

    let payload = [];

    payload.push(
      { type: typesofgenerators },
      {
        form: {
          values: paramsValues
        }
      }
    );

    this.setState({ isLoading: true });
    axios
      .post(`${API_HOST}/openai/api-response/request_inter_api`, {
        payload
      })
      .then((response) => {
        history.replace(
          `/assistente-pessoal-retorno-v0/${response.data.api_response_id}`
        );
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        console.error(error);
        toast.error('Ocorreu um erro, Tente novamente.');
      });
  };

  componentDidUpdate(previousProps, previousState) {
    if (previousState.apiInfo !== this.state.apiInfo) {
      this.fetchHabilidade();
    }
  }

  render() {
    const {
      isLoading,
      areaConhecimentoOption,
      matrizReferenciaOption,
      habilidadeOption,
      periodoOptions,
      componenteCurricularOption,
      apiInfo,
      typesofgeneratorsMap
    } = this.state;

    const showTab = true;
    if (showTab) {
      return (
        <>
          <div style={{ marginTop: '24px' }}>
            <div className="container mb-4 pb-4">
              <div className="row">
                <div className="col-12">
                  <div
                    className="card"
                    style={{ backgroundColor: '#f7f7f7', borderRadius: '10px' }}
                  >
                    <Nav
                      style={{
                        fontSize: '19px',
                        fontWeight: 600,
                        color: '#607173',
                        borderRadius: '10px 10px 0px 0px',
                        background: '#fff'
                      }}
                      tabs
                    >
                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '5'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '5'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/inter">
                              <NavLink
                                className={classnames({
                                  active_tab: false
                                })}
                              >
                                Plano de intervenção
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}
                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '1'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '1'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/plan">
                              <NavLink
                                className={classnames({
                                  active_tab: false
                                })}
                              >
                                Sugestão Pedagógica
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '2'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '2'
                        )[0].enabled ? (
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: true
                              })}
                            >
                              Atividade Individual
                            </NavLink>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '3'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '3'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/group">
                              <NavLink
                                className={classnames({
                                  active:
                                    this.state.activeTab ===
                                    'matrizes_referencia'
                                })}
                              >
                                Atividades em Grupo
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}

                      {typesofgeneratorsMap.filter(
                        (values) => values.codigo === '4'
                      )[0] ? (
                        typesofgeneratorsMap.filter(
                          (values) => values.codigo === '4'
                        )[0].enabled ? (
                          <NavItem>
                            <Link to="/assistente-pessoal-form/indplan">
                              <NavLink
                                className={classnames({
                                  active:
                                    this.state.activeTab ===
                                    'historico_utilizacao'
                                })}
                                to="teste"
                              >
                                Plano Individual
                              </NavLink>
                            </Link>
                          </NavItem>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}
                    </Nav>
                    <div className="card-body">
                      <div style={{ textAlign: 'center', padding: '1.5rem' }}>
                        <span
                          style={{
                            fontSize: '22px',
                            fontWeight: 'bold'
                          }}
                        >
                          Preencha os dados abaixo para que o sistema gere o seu
                          Plano de Atividade Individual
                        </span>
                      </div>
                      <Form
                        getApi={(formApi) => {
                          this.formApi = formApi;
                        }}
                      >
                        {({ formState }) => <div className="row"></div>}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}
                        >
                          <div className="input-type-style row">
                            <div className="col-md-6">
                              <label
                                style={{ marginBottom: '-1rem' }}
                                htmlFor="Área do conhecimento"
                                className="input-label-style"
                              >
                                <span className="filter-label">
                                  Área do conhecimento{' '}
                                </span>
                              </label>
                              <InputSelect
                                label=""
                                field="area_conhecimento"
                                onChange={async (e) => {
                                  this.fetchMatrizReferencia(
                                    e ? e.value : null
                                  );
                                  this.fetchComponentesCurriculares(e.value);
                                  await this.setState({
                                    apiInfo: {
                                      ...apiInfo,
                                      area_conhecimento: e.value
                                    }
                                  });
                                  this.fetchHabilidade();
                                }}
                                options={areaConhecimentoOption}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor="Componente"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">
                                  Componente curricular
                                </span>
                              </label>
                              <InputSelect
                                key={componenteCurricularOption}
                                label=""
                                field="componente"
                                options={componenteCurricularOption}
                              />
                            </div>
                          </div>
                          <div className="input-type-style row">
                            <div className="col-md-6">
                              <label
                                htmlFor="Matriz de referência"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">
                                  Matriz de referência
                                </span>
                              </label>
                              <InputSelect
                                autoload
                                label=""
                                col="col-md-12"
                                field="matriz_referencia"
                                options={matrizReferenciaOption}
                                onChange={(e) => {
                                  this.setState({
                                    apiInfo: { ...apiInfo, matriz: e.value }
                                  });
                                  this.fetchHabilidade();
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor="Habilidade"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">Habilidade</span>
                              </label>
                              <InputSelect
                                autoload
                                label=""
                                col="col-md-12"
                                field="habilidade"
                                options={habilidadeOption}
                                onChange={(e) => {
                                  this.setState({
                                    apiInfo: { ...apiInfo, habilidade: e.value }
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="input-type-style row">
                            <div className="col-md-6">
                              <label
                                htmlFor="Série/Ano"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">Série/Ano</span>
                              </label>
                              <InputSelect
                                key={periodoOptions}
                                label=""
                                field="serie"
                                options={periodoOptions}
                                onChange={(e) => {
                                  this.setState({
                                    apiInfo: { ...apiInfo, serie: e.value }
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor="Tipo questao"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">
                                  Tipo de questão
                                </span>
                              </label>
                              <div
                                style={{
                                  display: 'flex',
                                  width: '240px',
                                  paddingTop: '35px'
                                }}
                              >
                                <InputCheckbox
                                  label="Multipla escolha"
                                  field="multiplaescolha"
                                  onChange={(e) =>
                                    this.setState({
                                      apiInfo: {
                                        ...apiInfo,
                                        multiplaescolha: e.target.checked
                                      }
                                    })
                                  }
                                />
                                <InputCheckbox
                                  label="Discursiva"
                                  field="discursiva"
                                  onChange={(e) =>
                                    this.setState({
                                      apiInfo: {
                                        ...apiInfo,
                                        discursiva: e.target.checked
                                      }
                                    })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="input-type-style row">
                            <div
                              className="col-md-12"
                              style={{
                                textAlign: 'center'
                              }}
                            >
                              <p
                                style={{
                                  fontSize: '16px',
                                  marginBottom: '-1rem'
                                }}
                              >
                                Defina a quantidade de:
                              </p>
                            </div>
                          </div>
                          <div className="input-type-style row">
                            <div className="col-md-4">
                              <label
                                htmlFor="Questões Múltipla escolha"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">
                                  Questões Múltipla escolha
                                </span>
                              </label>
                              <input
                                style={{
                                  marginTop: '25px',
                                  width: '290px',
                                  height: '38px',
                                  border: '1px solid #EEE',
                                  borderRadius: '8px',
                                  background: '#FFF'
                                }}
                                type="number"
                                disabled={!apiInfo.multiplaescolha}
                                label=""
                                field="multiplaescolha"
                                // mask_="9"
                                onChange={(e) =>
                                  this.setState({
                                    apiInfo: {
                                      ...apiInfo,
                                      multiplaescolha: parseInt(e.target.value)
                                    }
                                  })
                                }
                              />
                            </div>
                            <div className="col-md-4">
                              <label
                                htmlFor="Alternativas"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">
                                  Alternativas
                                </span>
                              </label>
                              <input
                                style={{
                                  marginTop: '25px',
                                  width: '290px',
                                  height: '38px',
                                  border: '1px solid #EEE',
                                  borderRadius: '8px',
                                  background: '#FFF'
                                }}
                                type="number"
                                disabled={!apiInfo.multiplaescolha}
                                label=""
                                field="alternativas_multiplaescolha"
                                // mask_="9"
                                onChange={(e) =>
                                  this.setState({
                                    apiInfo: {
                                      ...apiInfo,
                                      multiplaescolhaAlts: parseInt(
                                        e.target.value
                                      )
                                    }
                                  })
                                }
                              />
                            </div>
                            <div className="col-md-4">
                              <label
                                htmlFor="Discursivas"
                                className="input-label-style"
                                style={{ marginBottom: '-1rem' }}
                              >
                                <span className="filter-label">
                                  Discursivas
                                </span>
                              </label>
                              <input
                                style={{
                                  marginTop: '25px',
                                  width: '290px',
                                  height: '38px',
                                  border: '1px solid #EEE',
                                  borderRadius: '8px',
                                  background: '#FFF'
                                }}
                                type="number"
                                disabled={!apiInfo.discursiva}
                                label=""
                                field="discursivas"
                                mask_="9"
                                onChange={(e) =>
                                  this.setState({
                                    apiInfo: {
                                      ...apiInfo,
                                      discursiva: parseInt(e.target.value)
                                    }
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              width: '100%'
                            }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                width: '100%'
                              }}
                            >
                              <div className="input-type-style row">
                                <div className="col-md-12">
                                  <label
                                    htmlFor="Dificuldade"
                                    className="input-label-style"
                                    style={{
                                      marginBottom: '-1rem',
                                      width: '300px'
                                    }}
                                  >
                                    <span className="filter-label">
                                      Nível de dificuldade
                                    </span>
                                  </label>
                                  <div
                                    style={{
                                      display: 'flex',
                                      width: '100px',
                                      paddingTop: '35px'
                                    }}
                                  >
                                    <InputCheckbox
                                      label="Fácil"
                                      field="facil"
                                      value="facil"
                                      onChange={(e) =>
                                        this.setState({
                                          apiInfo: {
                                            ...apiInfo,
                                            facil: e.target.checked
                                          }
                                        })
                                      }
                                    />
                                    <InputCheckbox
                                      label="Médio"
                                      field="medio"
                                      value="medio"
                                      onChange={(e) =>
                                        this.setState({
                                          apiInfo: {
                                            ...apiInfo,
                                            medio: e.target.checked
                                          }
                                        })
                                      }
                                    />
                                    <InputCheckbox
                                      label="Difícil"
                                      field="dificil"
                                      value="dificil"
                                      onChange={(e) =>
                                        this.setState({
                                          apiInfo: {
                                            ...apiInfo,
                                            dificil: e.target.checked
                                          }
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="input-type-style"
                            style={{
                              display: 'flex',
                              justifyContent: 'center'
                            }}
                          >
                            <button
                              style={{
                                color: 'white',
                                backgroundColor: this.props.theme.primary,
                                border: 'none',
                                fontSize: '1rem',
                                fontWeight: '600',
                                textAlign: 'center',
                                cursor: 'pointer',
                                borderRadius: '15px',
                                boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                letterSpacing: '1px',
                                padding: '4px 16px',
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'row',
                                alignItems: 'center'
                              }}
                              onClick={() => this.formApiData()}
                              disabled={isLoading}
                            >
                              + Gerar Sugestão Pedagógica
                            </button>
                            <Modal
                              style={{ marginTop: '500px' }}
                              size="lg"
                              isOpen={isLoading}
                              toggle={this.toggle}
                            >
                              <ModalBody style={{ padding: '1.5rem' }}>
                                <div style={{ textAlign: 'center' }}>
                                  <img
                                    src={get(this.props.theme, 'loadingGif')}
                                    style={{ width: '42px' }}
                                    alt=""
                                  />
                                  <p style={{ color: '#000' }}>
                                    Gerando (Tempo médio de 3 minutos), por
                                    favor aguarde um momento
                                  </p>
                                  <p style={{ color: '#f00' }}>
                                    Mantenha está aba do navegador aberta
                                    durante todo o processo.
                                  </p>
                                </div>
                              </ModalBody>
                            </Modal>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}

export default withTheme(GPTForm);
